import { useTranslation } from 'react-i18next'

function LanguageSwitcher() {
  const { i18n } = useTranslation()

  // Use resolvedLanguage for more reliable detection
  const lang = i18n.resolvedLanguage || i18n.language || 'en'
  const currentLang = lang.startsWith('en') ? 'en' : 'es'

  const toggleLanguage = () => {
    const newLang = currentLang === 'en' ? 'es' : 'en'
    i18n.changeLanguage(newLang)
  }

  // Show flag of language you can switch TO
  const targetFlag = currentLang === 'en' ? (
    // Spanish flag - switch to Spanish
    <svg viewBox="0 0 60 60" className="w-24 h-24 rounded-full">
      <clipPath id="circleClipES">
        <circle cx="30" cy="30" r="30"/>
      </clipPath>
      <g clipPath="url(#circleClipES)">
        <rect y="0" width="60" height="20" fill="#c60b1e"/>
        <rect y="20" width="60" height="20" fill="#ffc400"/>
        <rect y="40" width="60" height="20" fill="#c60b1e"/>
      </g>
    </svg>
  ) : (
    // UK flag - switch to English
    <svg viewBox="0 0 60 60" className="w-24 h-24 rounded-full">
      <clipPath id="circleClipUK">
        <circle cx="30" cy="30" r="30"/>
      </clipPath>
      <g clipPath="url(#circleClipUK)">
        <rect width="60" height="60" fill="#012169"/>
        <path d="M0,0 L60,60 M60,0 L0,60" stroke="#fff" strokeWidth="12"/>
        <path d="M0,0 L60,60" stroke="#c8102e" strokeWidth="4" transform="translate(2,0)"/>
        <path d="M60,0 L0,60" stroke="#c8102e" strokeWidth="4" transform="translate(-2,0)"/>
        <path d="M30,0 V60 M0,30 H60" stroke="#fff" strokeWidth="16"/>
        <path d="M30,0 V60 M0,30 H60" stroke="#c8102e" strokeWidth="8"/>
      </g>
    </svg>
  )

  return (
    <button
      onClick={toggleLanguage}
      className="p-8 rounded-full hover:bg-beige transition-colors flex items-center justify-center"
      aria-label={currentLang === 'en' ? 'Cambiar a español' : 'Switch to English'}
      title={currentLang === 'en' ? 'Cambiar a español' : 'Switch to English'}
    >
      {targetFlag}
    </button>
  )
}

export default LanguageSwitcher
